import { useUser } from '@hilma/auth';
import { Customer } from '@hilma/netina2all';

const useCustomer = () => useUser<Customer | null>();

export default useCustomer;